let modulePromise = null;
export const getSimpleSearchFilterModule = ()=>{
    if (!modulePromise) {
        modulePromise = import('./simple-search-filter');
    }
    return modulePromise;
};
